<app-header-title>
  <span title>{{'publicsetting.jobTitleStructure'|translate}}</span>
</app-header-title>



<div style="padding: 0rem 3rem">
  <dx-data-grid id="gridContainer" [dataSource]="dataSource" [allowColumnReordering]="true" [showBorders]="false"
    (onInitNewRow)="onInitNewRowE($event)" (onRowUpdating)="updateRow($event)" (onRowInserted)="onRowInserted($event)"
    (onRowRemoved)="onRowRemoved($event)" style="margin: 2rem auto; width: 90%;" [errorRowEnabled]="false"
    [rtlEnabled]="currentLang=='ar'?true:false">

    <dxo-paging [enabled]="true"></dxo-paging>

    <dxo-editing mode="form" [allowUpdating]="true" [allowDeleting]="true" [allowAdding]="true" [texts]="button">
  <dxo-form labelMode="floating" labelLocation="top">
  </dxo-form>
      <dxo-texts [addRow]="addrowfun('publicsetting.jobTitleStructure')"
        confirmDeleteMessage="{{'tableinfo.deletebutton'|translate}}" SaveConfirm>
      </dxo-texts>
    </dxo-editing>

      <dxi-column dataField="managementId" caption="{{'addemployee.tab1.management'|translate}}">
        <dxo-lookup [dataSource]="managemetList" displayExpr="nameAr" valueExpr="id"></dxo-lookup>
      </dxi-column>
      <dxi-column dataField="jobTitleId" caption="{{'addemployee.tab1.JobTitle'|translate}}">
        <dxo-lookup [dataSource]="jobTitleList" displayExpr="nameAr" valueExpr="id"></dxo-lookup>
      </dxi-column>
      <dxi-column dataField="numberOfPosition" caption="{{'publicsetting.numberOfPosition'|translate}}">
        <dxi-validation-rule type="required" message="{{'errors.namerequired'|translate}}">
        </dxi-validation-rule>
      </dxi-column>
  </dx-data-grid>

  <dx-button stylingMode="outlined" text="{{'employeeduration.submit'|translate}}" type="default"
    (onClick)="onFormSubmit($event)" [disabled]="!isGridValid">
  </dx-button>
</div>